import axiosInstance from "../lib/axios";

const BASE_URL = "/student-membership";

// ----------------------------
// Public APIs
// ----------------------------

// Register a new student
export const registerStudent = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/register`, payload);
    return res.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Registration failed");
  }
};

// Login student
export const loginStudent = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/login`, payload);
    return res.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Login failed");
  }
};

// ----------------------------
// Email Verification
// ----------------------------
export const sendEmailOtp = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/email/send-otp`, payload);
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to send email OTP"
    );
  }
};

export const verifyEmailOtp = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/email/verify-otp`,
      payload
    );
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Email verification failed"
    );
  }
};

// ----------------------------
// Mobile Verification
// ----------------------------
export const sendMobileOtp = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/mobile/send-otp`,
      payload
    );
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to send mobile OTP"
    );
  }
};

export const verifyMobileOtp = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/mobile/verify-otp`,
      payload
    );
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Mobile verification failed"
    );
  }
};

// ----------------------------
// Forgot Password Flow
// ----------------------------
export const sendForgotPasswordOtp = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/password/forgot/send-otp`,
      payload
    );
    return res.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to send OTP");
  }
};

export const resendForgotPasswordOtp = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/password/forgot/resend-otp`,
      payload
    );
    return res.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to resend OTP");
  }
};

export const verifyForgotPasswordOtp = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/password/forgot/verify-otp`,
      payload
    );
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "OTP verification failed"
    );
  }
};

export const resetForgotPassword = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/password/reset`, payload);
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to reset password"
    );
  }
};

// ----------------------------
// Protected Routes
// ----------------------------
export const getStudentById = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch student"
    );
  }
};

export const updateStudent = async (id, payload) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, payload);
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update student"
    );
  }
};

// ----------------------------
// Admin Routes
// ----------------------------
export const updateMembershipStatus = async (id, payload) => {
  try {
    const res = await axiosInstance.patch(`${BASE_URL}/${id}/status`, payload);
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update status"
    );
  }
};

export const getStudentsByStatus = async (params) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/status/list`, { params });
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch students"
    );
  }
};

/**
 *  Update student login auth status (active / inactive)
 */
export const updateLoginAuthStatus = async (id, loginAuthStatus) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/login-status/${id}`, {
      loginAuthStatus,
    });
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update login auth status"
    );
  }
};

/**
 *  Delete student membership
 */
export const deleteStudentMembership = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete student membership"
    );
  }
};

export const changePassword = async (id, payload) => {
  try {
    const res = await axiosInstance.put(
      `${BASE_URL}/change-password/${id}`,
      payload
    );
    return res.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to change password"
    );
  }
};
